module.exports = __webpack_public_path__ + "static/media/satisfied-primary.91d902d2.svg";